/**
 * Returns pending booking request count for hosting tab badge.
 * Wired to real Supabase data via useHostStats.
 */
import { useAuth } from './use-auth'
import { useHostStats } from './use-hosting-dashboard'

export function usePendingBookingsCount(): number {
  const { user } = useAuth()
  const { stats } = useHostStats(user?.id ?? '')
  return stats?.pendingBookings ?? 0
}
